import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import PostCreate from "../PostCreate";

// SocialRouteLayer in App.js already owns the modal backdrop.
export default function PostCreatePage() {
  const navigate = useNavigate(),
    published = useRef(false);
  return (
    <PostCreate
      open
      onClose={() => {
        if (!published.current) navigate(-1);
      }}
      onPublished={(postId) => {
        published.current = true;
        navigate("/post/" + postId, { replace: true });
      }}
    />
  );
}
